import { ResumeEntryObject } from '../components/sections/resume/ResumeEntry';
import jsonResumes from '../data/resumes.json'

export class ResumeRepository {

    getAllResumes(): ResumeEntryObject[] {
        return jsonResumes.resumes.map((resume): ResumeEntryObject => {
            return {
                title: resume.title,
                subtitle: resume.subtitle,
                description: resume.description,
                startYear: resume.startYear,
                endYear: resume.endYear
            }
        }).sort((a, b) => (a.startYear < b.startYear) ? 1 : -1);
    }
}